/**
 * Liest die Gruppen-IDs aus localStorage aus und gibt true zurück,
 * sobald eine der gefragten IDs im Array enthalten ist.
 *
 * @param requiredGroups - beliebig viele Gruppen-IDs
 * @returns true, wenn der User mindestens eine der requiredGroups hat
 */
export function isSuperadmin(): boolean {
    return localStorage.getItem("is_superadmin") === "true";
}

/**
 * true, wenn der eingeloggte Nutzer Django-`is_staff` ODER `is_superuser` ist —
 * bewusst gruppenunabhängig. Steuert u. a. die Sichtbarkeit der Funktionen-
 * (Modul-)Einstellungen. Nur kosmetisch; das Backend erzwingt dieselbe Regel.
 */
export function isStaffOrSuperadmin(): boolean {
    return localStorage.getItem("is_staff") === "true" || isSuperadmin();
}

export function checkPermission(...requiredGroups: number[]): boolean {
    // 1) Wenn Superadmin, immer erlauben
    if (isSuperadmin()) {
        return true;
    }

    // 2) Ansonsten ganz normal die Gruppen checken
    const raw = localStorage.getItem("groups");
    if (!raw) return false;

    let userGroups: number[];
    try {
        userGroups = JSON.parse(raw);
    } catch {
        console.error('Ungültiges JSON in localStorage unter "groups":', raw);
        return false;
    }

    return requiredGroups.some(id => userGroups.includes(id));
}


export function getCurrentUserId() {
    return Number(localStorage.getItem('user_id'));
}
